import type { TranslationMessages } from './types';

export const faq: TranslationMessages = {
  title: 'Frequently Asked Questions',
  description: 'Here are some common questions about using NEKO POS.',
  howToReportBug: {
    question: 'How do I report a bug?',
    answer:
      'Click the Support button in the header, choose "Bug report", then describe the problem and (optionally) attach a screenshot. This will send full diagnostic information to our team.',
  },
  howToRequestFeature: {
    question: 'How do I request a new feature?',
    answer:
      'You can request new features through your account manager or by including your suggestion in a bug report. Please be as specific as possible about your workflow and desired outcome.',
  },
  urgentSupport: {
    question: 'What should I do if the POS is down or I need urgent support?',
    answer:
      'Follow your store\'s escalation process (phone/Chat/Slack) to contact the NEKO support team. Include the store name, current issue, and any relevant order IDs so we can help you faster.',
  },
};
